<script>
  // ?id=21379&dnApp=1&dnAppVersion=6.5.5
  // ?id=21379&dnApp=1&dnAppVersion=6.5.5&darkMode=1

  import { onMount, tick } from "svelte";

  import EventRow from "./EventRow.svelte";
  // import HockeyPlayoffBracket from "./HockeyPlayoffBracket.svelte";
  import EmbedTracker from "./EmbedTracker.svelte";


  import { baseUrl, getUrlVars } from "../../../../../scripts/loadExternalData";

  import {
    handleDarkModeSettings,
    darkModeClass,
    marginClass
  } from "../../../../../scripts/darkMode";

  import { burstPostRatio } from "../../../../../scripts/helpers.js";



  let expanded = new Set();
  let collapsed = new Set();
  let expandLocked = false; // true = låst (går inte öppna), false = normalt

  let mainEl;

  let loading = true;

  /** Alla event-rader (objekt) */
  let events = [];

  /** Dag-lista för nav */
  let days = []; // [{ iso: "2026-02-04", label: "04 onsdag" }, ...]

  /** Vald dag */
 let selectedDayIso = "ALLA";

  let selectedSport = "ALLA";

  let participantsById = {}; // { "2": {id, Namn, Sport, ...}, ... }

  let selectedPersonId = "ALLA";

  let creditsOpen = false;

  let firedebug = false;

  // Tillfällig hårdkodad lista (sen kan den komma från Patron)
const persons = [
  { titel: "st", id: "41", namn: "William Poromaa" },
  { titel: "st", id: "67", namn: "Elias Pettersson" },
  
  { titel: "op", id: "42", namn: "Anna Magnusson" },
  { titel: "op", id: "1", namn: "Anna Swenn-Larsson" },
  { titel: "op", id: "63", namn: "Anna-Karin Heijdenberg" },
  { titel: "op", id: "2", namn: "Cornelia Öhlund" },
  { titel: "op", id: "16", namn: "David Mobärg" },
  { titel: "op", id: "30", namn: "Ebba Andersson" },
  { titel: "op", id: "31", namn: "Edvin Anger" },
  { titel: "op", id: "43", namn: "Ella Halvarsson" },
  { titel: "op", id: "44", namn: "Elvira Öberg" },
  { titel: "op", id: "32", namn: "Emma Ribom" },
  { titel: "op", id: "17", namn: "Erik Mobärg" },
  { titel: "op", id: "33", namn: "Frida Karlsson" },
  { titel: "op", id: "34", namn: "Gustaf Berglund" },
  { titel: "op", id: "45", namn: "Hanna Öberg" },
  { titel: "op", id: "64", namn: "Henning Sjökvist" },
  { titel: "op", id: "51", namn: "Henrik Harlaut" },
  { titel: "op", id: "46", namn: "Jesper Nelin" },
  { titel: "op", id: "52", namn: "Jesper Tjäder" },
  { titel: "op", id: "58", namn: "Johan Häggström" },
  { titel: "op", id: "36", namn: "Jonna Sundling" },
  { titel: "op", id: "62", namn: "Linn Gestblom" },
  { titel: "op", id: "37", namn: "Linn Svahn" },
  { titel: "op", id: "19", namn: "Linnea Mobärg" },
  { titel: "op", id: "47", namn: "Malte Stefansson" },
  { titel: "op", id: "48", namn: "Martin Ponsiluoma" },
  { titel: "op", id: "39", namn: "Moa Ilar" },
  { titel: "op", id: "4", namn: "Sara Hector" },
  { titel: "op", id: "49", namn: "Sebastian Samuelsson" },
  { titel: "op", id: "50", namn: "Viktor Brandt" },
  { titel: "op", id: "23", namn: "Walter Wallberg" },
  { titel: "op", id: "41", namn: "William Poromaa" },
  
  { titel: "gd", id: "4", namn: "Sara Hector" },
  { titel: "gd", id: "14", namn: "Sara McManus" },
  { titel: "gd", id: "67", namn: "Tre kronor herr" },
  { titel: "gd", id: "66", namn: "Tre kronor dam" },
  
  { titel: "na", id: "67", namn: "Philip Broberg" },
  
  { titel: "vlt", id: "67", namn: "Jesper Wallstedt" },
  { titel: "vlt", id: "67", namn: "Pontus Holmberg" },
  { titel: "vlt", id: "68", namn: "Mikael Fryklund" },
  
  { titel: "hdsxx", id: "20", namn: "Rasmus Stegfeldt" },
  { titel: "hdsxx", id: "67", namn: "Rasmus Andersson" },
  
  { titel: "ot", id: "66", namn: "Hilda Svensson" },
  { titel: "ot", id: "66", namn: "Ebba Svensson Träff" },

  { titel: "fk", id: "34", namn: "Gustaf Berglund" },
  { titel: "fk", id: "29", namn: "Anton Grahn" },
  { titel: "fk", id: "38", namn: "Maja Dahlqvist" }, 
  { titel: "fk", id: "57", namn: "Calle Halfvarsson" },
  { titel: "fk", id: "39", namn: "Moa Ilar" },
  { titel: "fk", id: "28", namn: "Alvar Myhlback" },
  { titel: "fk", id: "47", namn: "Malte Stefansson" },
  { titel: "fk", id: "1", namn: "Anna Swenn-Larsson" },
  { titel: "fk", id: "15", namn: "Sofia Scharback" },
  { titel: "fk", id: "43", namn: "Ella Halvarsson" },
  { titel: "fk", id: "64", namn: "Henning Sjökvist" },
  { titel: "fk", id: "31", namn: "Edvin Anger" },
  { titel: "fk", id: "67", namn: "Filip Forsberg" }, 
  { titel: "fk", id: "66", namn: "Maja Nylén Persson" }, 
  { titel: "fk", id: "66", namn: "Ida Karlsson" },
  { titel: "fk", id: "66", namn: "Nicole Hall" }, 

  { titel: "bt", id: "46", namn: "Jesper Nelin" }, 
  { titel: "bt", id: "35", namn: "Johanna Hagström" }, 

  { titel: "sdt", id: "31", namn: "Edvin Anger" }, 

];

const urlVars = getUrlVars();
const queryTitel = urlVars?.titel ?? null;

 $: visiblePersons = queryTitel
  ? persons.filter(p => p.titel === queryTitel)
  : persons;

  // Filterad lista för vald dag
$: dayEvents = events.filter((e) => {

    // ✅ när person är vald: visa inte passerade dagar
  if (selectedPersonId !== "ALLA" && String(e.datum_iso ?? "").trim() < TODAY_ISO) {
    return false;
  }
  
  if (selectedDayIso !== "ALLA" && e.datum_iso !== selectedDayIso) return false;
  if (selectedSport !== "ALLA" && String(e.sport ?? "").trim() !== selectedSport) return false;

  // ✅ person-filter: kolla om personens id finns i ev.deltagare
  // if (selectedPersonId !== "ALLA" && !isSwedishEvent(e)) return false;
  if (selectedPersonId !== "ALLA") {
    const ids = parseParticipantIds(e?.deltagare);
    if (!ids.includes(String(selectedPersonId))) return false;
  }

  return true;
});




// unika sporter (från allt data, inte bara vald dag)
$: sports = [
  "ALLA",
  ...Array.from(
    new Set(
      events
        .map((e) => String(e.sport ?? "").trim())
        .filter(Boolean)
    )
  ).sort((a, b) => a.localeCompare(b, "sv"))
];


$: selectedDayTitleTextx =
  selectedDayIso === "ALLA"
    ? "Alla dagar"
    : isTodayIso(selectedDayIso)
    ? "I dag"
    : (days.find((d) => d.iso === selectedDayIso)?.label ?? selectedDayIso);


$: selectedDayTitleText = dayTitle(selectedDayIso);


// Hjälp: label för en iso-dag
function dayLabel(iso) {
  return days.find((d) => d.iso === iso)?.label ?? iso;
}

// Gruppvisning: bara när vi visar ALLA dagar
$: groupedByDay = selectedDayIso === "ALLA"
  ? dayEvents.reduce((acc, ev) => {
      const iso = ev.datum_iso || "okänt";
      (acc[iso] ||= []).push(ev);
      return acc;
    }, {})
  : null;

// Sorterad lista av dag-nycklar
$: groupedDayIsos = groupedByDay
  ? Object.keys(groupedByDay).sort((a, b) => String(a).localeCompare(String(b)))
  : [];


// kvarvarande event från och med vald dag (för samma sport/person-filter)
$: remainingEventsx =
  selectedDayIso === "ALLA"
    ? []
    : events.filter((e) => {
        if (String(e.datum_iso ?? "") < selectedDayIso) return false;
        if (selectedSport !== "ALLA" && String(e.sport ?? "").trim() !== selectedSport) return false;

        if (selectedPersonId !== "ALLA") {
          const ids = parseParticipantIds(e?.deltagare);
          if (!ids.includes(String(selectedPersonId))) return false;
        }

        return true;
      });

// kommande event efter vald dag (för samma sport/person-filter)
$: remainingEvents =
  selectedDayIso === "ALLA"
    ? []
    : events.filter((e) => {
        // ✅ bara efter vald dag (inte samma dag)
        if (String(e.datum_iso ?? "") <= selectedDayIso) return false;

        if (selectedSport !== "ALLA" && String(e.sport ?? "").trim() !== selectedSport) return false;

        if (selectedPersonId !== "ALLA") {
          const ids = parseParticipantIds(e?.deltagare);
          if (!ids.includes(String(selectedPersonId))) return false;
        }

        return true;
      });


  onMount(async () => {
    await handleDarkModeSettings("Följ användarens tema");
    await fetchPatronData();
    burstPostRatio();
  });

function buildEventsFromQuickshot(json) {
  const fields = json?.fields ?? [];

  const table1 = fields.find((f) => f?.key === "table1");
  const table2 = fields.find((f) => f?.key === "table2");
  const table4 = fields.find((f) => f?.key === "table4");

  // ---------- TABLE 1 (events) ----------
  let evs = [];
  let ds = [];

  if (table1?.columns && Array.isArray(table1?.value)) {
    const cols = table1.columns;

    evs = table1.value.map((row) => {
      const obj = {};
      cols.forEach((c, i) => {
        obj[c] = row?.[i] ?? "";
      });
      return obj;
    });

    /*
    evs.forEach(ev => {
      if (ev.sport === "Hopp") {
      ev.sport = "Freeskiing";
      }
    });
    */

    //console.log(evs);

    const seen = new Set();
    ds = [];
    for (const e of evs) {
      const iso = e.datum_iso;
      if (!iso || seen.has(iso)) continue;
      seen.add(iso);
      ds.push({ iso, label: e.dag || iso });
    }
    ds.sort((a, b) => String(a.iso).localeCompare(String(b.iso)));
    //console.log(ds);
  }

  // ---------- TABLE 2 (participants) ----------
  let byId = {};
  if (table2?.columns && Array.isArray(table2?.value)) {
    const cols = table2.columns;

    const people = table2.value.map((row) => {
      const obj = {};
      cols.forEach((c, i) => {
        obj[c] = row?.[i] ?? "";
      });
      return obj;
    });

    byId = Object.fromEntries(
      people
        .filter((p) => String(p.id ?? "").trim() !== "")
        .map((p) => [String(p.id).trim(), p])
    );
  }


// ---------- TABLE 4 (firedebug) ----------
// Tabell 4: kolumner ["Rubrik","Ingress"] och första raden: ["debug","true"]
let firedebugLocal = false;

if (table4?.columns && Array.isArray(table4?.value) && table4.value.length) {
  const cols = table4.columns;
  const firstRow = table4.value[0] ?? [];

  //.log(cols);

  const rowObj = {};
  cols.forEach((c, i) => {
    rowObj[String(c || "").trim()] = firstRow?.[i] ?? "";
  });

  // stöd både "Rubrik/Ingress" och "rubrik/ingress"
  const rubrik = String(rowObj.Rubrik ?? rowObj.rubrik ?? "").trim().toLowerCase();
  const ingress = String(rowObj.Ingress ?? rowObj.ingress ?? "").trim().toLowerCase();

  //console.log(rubrik);
  //console.log(ingress);

  if (rubrik === "debug") {
    firedebugLocal = ["true", "1", "x", "yes", "ja"].includes(ingress);
  }
  //console.log(firedebugLocal);
}


  // Lägg stabil key per iso på varje event
const countByIso = {};
evs = evs.map((ev) => {
  const iso = String(ev?.datum_iso ?? "");
  const i = countByIso[iso] ?? 0;
  countByIso[iso] = i + 1;

  return { ...ev, __k: `${iso}|${i}` };
});

  return { events: evs, days: ds, participantsById: byId,firedebug: firedebugLocal };
}




  async function fetchPatronData() {


    try {
      const res = await fetch(`${baseUrl}/fields/${getUrlVars().id}`);
      const json = await res.json();

      const built = buildEventsFromQuickshot(json);
      events = built.events;


      days = built.days;
      participantsById = built.participantsById;

      firedebug = built.firedebug;

      if (days.length) {
        const todayIso = todayIsoLocal();

        // finns idag i OS-dagarna?
        const todayDay = days.find(d => d.iso === todayIso);

        selectedDayIso = todayDay
          ? todayDay.iso      // spelen pågår → idag
          : days[0].iso;      // annars → första OS-dagen
      }

// detta gör att allat är kollapsat från början


collapsed = new Set(
  events
    .filter(isSwedishEvent) // eller ta bort om du vill stänga ALLA
    .map(ev => ev.__k)
    .filter(Boolean)
);
  

    } catch (e) {
      console.error("Kunde inte hämta schema:", e);
      events = [];
      days = [];
    } finally {
      loading = false;
    }
  }



    function flagFile(name) {
    return name
      .toLowerCase()
      .replace(/å/g, "a")
      .replace(/ä/g, "a")
      .replace(/ö/g, "o")
      .replace(/\s+/g, "-");
  }
  

  function isSwedishEvent(ev) {

  return String(ev?.svensk_event ?? "").trim().toUpperCase() === "X";
}

function rowKey(i) {
  // unikt inom vald dag (vi byter ändå listan när man byter dag)
  return `${selectedDayIso}|${i}`;
}

function toggleExpanded(key) {
  const next = new Set(expanded);
  if (next.has(key)) next.delete(key);
  else next.add(key);
  expanded = next;
}

function toggleCollapsed(key) {


  if (expandLocked) return; // ✅ låst = ignorera klick

  const next = new Set(collapsed);
  if (next.has(key)) next.delete(key);
  else next.add(key);
  collapsed = next;

  burstPostRatio();
}

async function onSportChange(newSport) {

  
  
  selectedSport = newSport;

  // Om man väljer specifik gren → visa alla dagar
  if (selectedSport !== "ALLA") {
    //selectedDayIso = "ALLA";
    
  }
  selectedPersonId = "ALLA";
  
    await tick();        // ⬅️ VIKTIG
  collapseAll();


  burstPostRatio();
}

async function selectDay(iso) {

  selectedDayIso = iso;

  // Om man väljer specifik dag → visa alla grenar
  if (selectedDayIso !== "ALLA") {
    // selectedSport = "ALLA";
    
  }
  selectedPersonId = "ALLA";

  mainEl?.scrollIntoView?.({ behavior: "smooth", block: "start" });

   await tick();        // ⬅️ VIKTIG
  collapseAll();
  burstPostRatio();
}

function dayRowKey(iso, i) {
  return `${iso}|${i}`;
}

function parseParticipantIds(s) {
  return String(s ?? "")
    .split(",")
    .map((x) => x.trim())
    .filter(Boolean);
}

function getParticipantsForEvent(ev) {
  const ids = parseParticipantIds(ev?.deltagare);
  return ids.map((id) => participantsById[id]).filter(Boolean);
}



async function onPersonChange(id) {

  selectedPersonId = id;

  // När man väljer en person: visa alla dagar och alla grenar
  // (så man inte “råkar” filtrera bort deras event)
  if (selectedPersonId !== "ALLA") {
    selectedDayIso = "ALLA";
    selectedSport = "ALLA";
  }
  await tick();        // ⬅️ VIKTIG
  collapseAll();

  burstPostRatio();
}

function selectedDayTitle() {
  // console.log('test');
  if (selectedDayIso === "ALLA") return "Alla dagar";

  if (isTodayIso(selectedDayIso)) return "I dag";

  return (
    days.find((d) => d.iso === selectedDayIso)?.label ??
    selectedDayIso
  );
}


    function todayIsoLocal() {
      const t = new Date();
      return (
        t.getFullYear() +
        "-" +
        String(t.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(t.getDate()).padStart(2, "0")
      );
    }

    const TODAY_ISO = todayIsoLocal();

    

    function isTodayIso(iso) {
      // console.log(iso);
      // console.log(TODAY_ISO);
      return String(iso ?? "").trim() === TODAY_ISO;
    }

function isPastIsoDay(iso) {
  // jämför som sträng funkar för YYYY-MM-DD
  return String(iso ?? "").trim() < TODAY_ISO;
}

    function toggleCredits() {
      creditsOpen = !creditsOpen;
      burstPostRatio();
    }





function competitionWord(sport) {
  const s = String(sport ?? "").toLowerCase();
  return s === "ishockey" || s === "curling" ? "matcher" : "tävlingar";
}






function isTomorrowIso(iso) {
  const d = new Date();
  d.setDate(d.getDate() + 1);

  const tomorrowIso =
    d.getFullYear() +
    "-" +
    String(d.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(d.getDate()).padStart(2, "0");

  return String(iso ?? "").trim() === tomorrowIso;
}

function formatIsoToLongSv(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;

  return d.toLocaleDateString("sv-SE", {
    weekday: "long",
    day: "numeric",
    month: "long"
  });
}

function dayTitle(iso) {
  if (!iso) return "";

  if (iso === "ALLA") return "Alla dagar";
  if (isTodayIso(iso)) return "I dag";


  // “Måndag 4 februari”
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;

  const s = d.toLocaleDateString("sv-SE", {
    weekday: "long",
    day: "numeric",
    month: "long"
  });

   if (isTomorrowIso(iso)) return "I morgon - <span class='fyra'>" +s.charAt(0).toUpperCase() + s.slice(1) +"</span>";

  // Stor bokstav på veckodagen
  return s.charAt(0).toUpperCase() + s.slice(1);
}



function collapseAll() {
  collapsed = new Set(
    events
      .filter(isSwedishEvent) // eller ta bort den om du vill stänga ALLA
      .map((ev) => ev.__k)
      .filter(Boolean)
  );
}
</script>


<svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
<symbol id="ds-expand_less" viewBox="0 0 24 24"><path d="m7.4 15.05-1.05-1.075L12 8.325l5.65 5.65-1.05 1.075-4.6-4.6-4.6 4.6Z"></path></symbol>
<symbol id="ds-expand_more" viewBox="0 0 24 24"><path d="M12 15.05 6.35 9.375l1.05-1.05 4.6 4.6 4.6-4.6 1.05 1.05L12 15.05Z"></path></symbol>
</svg>


<main bind:this={mainEl} class={`main__content-wrapper  ${$darkModeClass}`}>
  <div class="mainWrapper">
  <img class="dn-logo" class:hide={queryTitel !== "exp"} src="./local_assets/os2026/lock/dn.png" alt="Dagens Nyheter" />
  <div class="rubbe">OS-schemat – och alla svenskar</div>
  <div class="divider"></div>
  {#if loading}
    <p class="loading">Laddar schema…</p>
  {:else}
    {#if days.length}

        <nav class="day-nav" aria-label="Välj dag">
        <button
          type="button"
          class="day-link"
          class:is-active={selectedDayIso === "ALLA"}
          on:click={() => selectDay("ALLA")}
        >
          Alla
        </button>

        {#each days as d}
          <button
            type="button"
            class="day-link"
            class:is-active={d.iso === selectedDayIso}
            class:is-past={isPastIsoDay(d.iso)}
            on:click={() => selectDay(d.iso)}
          >
            {d.label.slice(0, 6)}
          </button>
        {/each}
      </nav>

      <div class="divider"></div>

      <div class="filters">
        <div class="filter-label">Gren:</div>

        <div class="sport-nav" aria-label="Välj gren">
          {#each sports as s}
            <button
              type="button"
              class="sport-link"
              class:is-active={s === selectedSport}
              on:click={() => onSportChange(s)}
            >
              {s === "ALLA" ? "Alla" : s}
            </button>
          {/each}

        </div>
      </div>
 <div class="divider"></div>



      {#if queryTitel && visiblePersons.length}
        <div class="filters">
          <div class="filter-label">Då tävlar:</div>

          <div class="person-nav" aria-label="Välj person">


            {#each visiblePersons as p (`${p.titel}|${p.id}|${p.namn}`)}
              <button
                type="button"
                class="person-link"
                class:is-active={p.id === selectedPersonId}
                on:click={() => onPersonChange(p.id)}
              >
                {p.namn}
              </button>
            {/each}

            <button
              type="button"
              class="person-link"
              class:is-active={selectedPersonId === "ALLA"}
              on:click={() => onPersonChange("ALLA")}
            >
              Alla
            </button>
          </div>
        </div>
      {/if}

    {/if}
    <div class="divider"></div>
    {#if !days.length}
      <p class="empty">Hittade inga dagar i schemat.</p>
    {:else}
      {#if selectedDayIso !== "ALLA"}
            <div class="day-header">
              <div class="day-title t1">
                {@html selectedDayTitleText}
              </div>
            </div>







<!-- dagens events (som vanligt) -->
{#if dayEvents.length > 0}
  <div class="schedule" role="list">
    {#each dayEvents as ev (ev.__k)}
      {@const sw = isSwedishEvent(ev)}
      {@const k = ev.__k}
      <EventRow
        {ev}
        {sw}
        open={!collapsed.has(k)}
        {k}
        toggleExpanded={toggleCollapsed}
        expandLocked={expandLocked}
        {flagFile}
        participants={getParticipantsForEvent(ev)}
      />
    {/each}
  </div>
{/if}

<!-- om dagen är tom: visa infon (som du redan gör) -->
{#if dayEvents.length === 0}
  <p class="empty">
    Ingen <span class="fem">{selectedSport}</span>
    {selectedDayTitleText === "I dag" ? "i dag." : "för denna dag."}<br>
    Kommande {competitionWord(selectedSport)} i
    <span class="fem">{selectedSport}</span> hittar du i listan nedan.<br>
  </p>
  <br>
{/if}

<!-- ✅ kommande: visa när sport är vald (oavsett om dagen var tom eller ej) -->
{#if selectedSport !== "ALLA" && remainingEvents.length}
<div class="schedule" role="list">
  {#each remainingEvents as ev, i (ev.__k)}
    {@const prevIso = i > 0 ? remainingEvents[i - 1]?.datum_iso : null}
    {@const sw = isSwedishEvent(ev)}
    {@const k = ev.__k}

    {#if ev.datum_iso !== prevIso}
      <div class="day-header">
        <div class="day-title testor">
          {@html dayTitle(ev.datum_iso)}
        </div>
      </div>
    {/if}

    
      <EventRow
        {ev}
        {sw}
        open={!collapsed.has(k)}
        {k}
        toggleExpanded={toggleCollapsed}
        expandLocked={expandLocked}
        {flagFile}
        participants={getParticipantsForEvent(ev)}
      />
    
  {/each}
  </div>
{/if}






















      {:else}
            {#each groupedDayIsos as iso}
              <div class="day-header">
                    <div class="day-title testor2">
                      {@html dayTitle(iso)}
                    </div>
              </div>

              {#if dayEvents.length === 0}
                <p class="empty">
                  Inga tävlingar matchar ditt val. {selectedSport}
                </p>
              {/if}

              <div class="schedule" role="list">
               {#each groupedByDay[iso] as ev (ev.__k)}
                  {@const sw = isSwedishEvent(ev)}
                  {@const k = ev.__k}
                  <EventRow
                    {ev}
                    {sw}
                    open={!collapsed.has(k)}
                    {k}
                    toggleExpanded={toggleCollapsed}
                    expandLocked={expandLocked}
                    {flagFile}
                    participants={getParticipantsForEvent(ev)}
                  />
                {/each}
              </div>
            {/each}
        {/if}
    {/if}  
  {/if}










<div class="divider"></div>
{#if queryTitel }
<section class="credits" aria-label="Källa och credits">
  <button
    type="button"
    class="credits__toggle"
    aria-expanded={creditsOpen}
    on:click={toggleCredits}
  >
    <span class="credits__summary">Källa: Dagens Nyheter, www.olympics.com</span>

    <svg class="credits__chev" aria-hidden="true" viewBox="0 0 24 24">
      <use href={creditsOpen ? "#ds-expand_less" : "#ds-expand_more"} />
    </svg>
  </button>


{#if creditsOpen}
  <div class="credits__body">
    <div class="credits__row">
      <div class="credits__label">Redaktör:</div>
      <div class="credits__value">Martin Fransson DN, Tove Nordenhäll DN</div>
    </div>

    <div class="credits__row">
      <div class="credits__label">Grafik:</div>
      <div class="credits__value">Stefan Rothmaier DN</div>
    </div>

    <div class="credits__row">
      <div class="credits__label">Programmering:</div>
      <div class="credits__value">Lukas Hansson DN</div>
    </div>
  </div>
{/if}
</section>
{/if}





{#if firedebug}
<EmbedTracker />
{/if}

  </div>
  
</main>

<style global type="text/scss" lang="scss">
  .main__light-mode {

    --gap: 0.8rem;

    --color-bg: #ededed;
    --color-bg-daynav: #ededed;
    --color-bg-card: #fff;
    --color-border: #b7b7b7;
    --color-border2: #222;

    --color-text-normal: #222;
    --color-text-gray: #666;
    --color-text-muted: #666;
    --special-text-color: #222;
    --special-text-color2: #222;

  }
  
  .main__dark-mode {
    --gap: 0.8rem;

    --color-bg: #333;
    --color-bg-daynav: #333;
    --color-bg-card: #171717;
    --color-border: #535353;
    --color-border2: #a6a6a6;

    --color-text-normal: #fff;
    --color-text-gray: #666;
    --color-text-muted: #666;
    --special-text-color: #222;
    --special-text-color2: #fff;
  }



body {
  overflow: visible;
}
  /* (du har redan darkmodeClass/marginClass i projektet, så vi låter dom styra basen) */


  .mainWrapper {

  position: relative;
  width: 100%;
  padding: 11px;
  box-sizing: border-box;
  background-color: var(--color-bg);
  max-width: 720px;
  margin: 0 auto 0 auto;

  }
  .rubbe {
    font-size: 2.2rem;
    font-weight: 700;
    margin: 0 0 1rem 0;
  }

  .loading,
  .empty {
    font-size: 1.8rem;
    color: var(--color-text-muted);
    margin: 1rem 0;
  }


.divider {
  position: relative;
  width: 100%;
  height: 1rem;
  background-color: transparent;
  margin:0;
  padding: 0;
}



  /* Dag-navigering */
  .day-nav {
    display: flex;
    flex-wrap: wrap;
    gap: 0.9rem 0.9rem;
    margin: 0 0 1rem 0;
    padding: 0;
  }

  .day-link {
    appearance: none;
    border: 1px solid var(--color-border);
    background: var(--color-bg-daynav);
    border-radius: 0px;
    padding: 0.6rem 1rem;
    font-size: 1.6rem;
    line-height: 1;
    cursor: pointer;
    color: var(--color-text-normal);
    font-variant-numeric: tabular-nums;
    font-feature-settings: "tnum";
    letter-spacing: 0.03em;
    min-width: 6rem;
  }

  .day-link.is-active {
    background: var(--color-bg-card);
    border-color: var(--color-border2);
    font-weight: 700;
  }

  .day-header {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
   margin: 1em 1em 1rem 0em;
  }

  .day-title {
    font-size: 1.9rem;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    font-feature-settings: "tnum";
  }

  /* Schema-lista */
  .schedule {
    display: flex;
    flex-direction: column;
    gap: var(--gap);
  }

  .event-row {
    display: flex;
    gap: 1rem;
    padding: 1rem;
    padding-left: 0px;
    
    border: 0 solid var(--color-border);
    border-top: 1px solid var(--color-border);
    border-bottom: 1px solid var(--color-border);
    

    border-radius: 0;
    background: var(--color-bg-card);
    flex-direction: column;
    color: var(--color-text-normal);
  }

  .event-body-wrapper {
    display: flex;
    gap: 1rem;
    padding: 1rem;
    padding-right: 0rem;
    padding-left: 2rem;
    flex-direction: row;

  }

  .event-time {
    flex: 0 0 5.5rem;
    font-size: 1.7rem;
    font-weight: 700;
    flex-direction: row;
  }

  .event-body {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
  }

.event-top {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 0.8rem;
}

.event-top-left {
  display: flex;
  gap: 0.6rem;
  align-items: baseline;
  flex-wrap: wrap;
}

.tv-kanal {
  font-size: 1.3rem;
  font-weight: 400;
  background: transparent;
  color: var(--color-text-gray);
  white-space: nowrap;
}

  .event-sport {
    font-size: 1.8rem;
    font-weight: 700;
  }

    .event-sport span  {
    font-weight: 400;
  }

  .event-arena {
    font-size: 1.6rem;
    color: var(--color-text-muted);
  }

  .event-info {
    font-size: 1.6rem;
    white-space: pre-line; /* hanterar "Damer Prelim.\nOmgång..." snyggt */
  }

  .event-teams {
    font-size: 1.6rem;
    display: flex;
    gap: 0.6rem;
    flex-wrap: wrap;
  }

  .team-row {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}

.team-name {
  font-size: 1.6rem;
  font-weight: 600;
}

.event-teams {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  flex-wrap: wrap;
}



  .vs {
    color: var(--color-text-muted);
  }





  .flagga-wrapper {
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 50%;
  overflow: hidden;
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.flagga {
  width: 120%;
  height: 120%;
  object-fit: cover;
}

.lock-wrapper {

  width: 5rem;
  height: 5rem;
  border-radius: 0;
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;

}

.lock {


}


.event-top-right {
  display: inline-flex;
  gap: 0.6rem;
  flex-direction: column;
  justify-content: flex-end;
  align-content: flex-end;
  align-items: flex-end;

}

.is-poss .event-top-right {

   justify-content: flex-end;
   line-height: 1;
  pointer-events: none;
  font-size: 1.5rem;


}


.event-channels {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
}

/* större svensk markör */
.flagga-wrapper--big {
  width: 5rem;
  height: 5rem;
}

/* knapp för expand */
.expand-btn {
  appearance: none;
  border: 0px solid var(--color-border);
  background: transparent;
  border-radius: 0.6rem;
  padding: 0.2rem 0.6rem;
  cursor: pointer;
  line-height: 1;
  pointer-events: none;
  font-size: 1.5rem;

  display: flex;
flex-direction: column;
  justify-content: flex-end;
  align-content: flex-end;
  align-items: flex-end;
}

.chev {
  font-size: 1.6rem;
  font-weight: 700;
}

/* expanderad text */
.event-expand {
  margin-top: 0.8rem;
  padding-top: 0.8rem;
  border-top: 1px solid var(--color-border);
  font-size: 1.6rem;
  color: var(--color-text-normal);
  white-space: pre-line;
}



/* valfri extra markering på hela raden */
.event-row.is-svenskx {
  border-left: 0.4rem solid #005293; /* svensk blå */
}

.event-row.is-svenskx  {
  position: relative;
  border-radius: var(--border-radius-small);
  background:
    linear-gradient(
      to bottom,
      #0c5f9b 0%,
      #0c5f9b 50%,
      #fed72a 50%,
      #fed72a 100%
    ) top / 100% 1rem no-repeat,
    var(--color-bg-card);
    padding-top: 2rem;
    
}

.event-row.is-svensk  {
  position: relative;
  background:#f9eb53;
  color:var(--special-text-color);
    
}



.event-row.is-svensk.is-open  .event-timex {
  flex: 0 0 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}



.event-row.is-poss {
  position: relative;
  background: linear-gradient(
    to left,
    #f9eb53 0%,
    var(--color-bg-card) 50%
  );
  color: var(--special-text-color);
}

.main__dark-mode .event-row.is-poss {
  position: relative;
  background: linear-gradient(
    to left,
    #d7cb3f 0%,
    var(--color-bg-card) 50%
  );
  color: var(--special-text-color2);
}



.filters {
  margin: 0 0 0.8rem 0;
  display: flex;
  gap: 1rem;
  align-items: center;
}

.filter-label {
  font-size: 1.6rem;
  font-weight: 600;
  display: inline-flex;
  gap: 0.6rem;
  align-items: center;
}

.filter-select {
  font-size: 1.6rem;
  padding: 0.5rem 0.8rem;
  border-radius: 0.6rem;
  border: 1px solid var(--color-border);
  background: var(--color-bg-card);
  color: var(--color-text-normal);
}


.expand-people {
  margin-top: 0.8rem;
  padding-top: 0.8rem;
  border-top: 0 solid var(--color-border);
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.person-card {
  border: 1px solid var(--color-border);
  border-radius: 0.6rem;
  padding: 0.8rem;
  background: rgba(0,0,0,0.03);
}

.person-top {
  display: flex;
  gap: 0.8rem;
  flex-wrap: wrap;
  align-items: baseline;
}

.person-name {
  font-size: 1.7rem;
  font-weight: 800;
}

.person-sport {
  font-size: 1.4rem;
  color: var(--color-text-muted);
  font-weight: 600;
}

.person-desc {
  margin-top: 0.4rem;
  font-size: 1.6rem;
  color: var(--color-text-normal);
}

.person-medals {
  margin-top: 0.6rem;
  font-size: 1.4rem;
  color: var(--color-text-muted);
}



.filters {
  margin: 0 0 0.8rem 0;
  display: flex;
  gap: 0.8rem;
  align-items: flex-start;
  flex-wrap: wrap;
}

.filter-label {
  font-size: 1.6rem;
  font-weight: 600;
  line-height: 1.2;
  padding-top: 0.55rem; // optiskt linjera med pills
}

.sport-nav {
  display: flex;
  flex-wrap: wrap;
  gap: 0.9rem 0.9rem;
}

.sport-link {
  appearance: none;
  border: 1px solid var(--color-border);
  background: var(--color-bg-daynav);
  border-radius: 0px;
  padding: 0.6rem 1rem;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  color: var(--color-text-normal);
  white-space: nowrap;
}

.sport-link.is-active {
  background: var(--color-bg-card);
  border-color: var(--color-text-normal);
  font-weight: 700;
}




.person-nav {
  display: flex;
  flex-wrap: wrap;
  gap: 0.9rem 0.9rem;
}

.person-link {
  appearance: none;
  border: 1px solid var(--color-border);
  background: var(--color-bg-daynav);
  border-radius: 0px;
  padding: 0.6rem 1rem;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  color: var(--color-text-normal);
  white-space: nowrap;
}

.person-link.is-active {
  background: var(--color-bg-card);
  border-color: var(--color-text-normal);
  font-weight: 700;
}

.person-nav .allabutton {
  display:none;
}


.credits {
  border: 1px solid var(--color-border);
  background: var(--color-bg-card);
  border-radius: 0;
}

.credits__toggle {
  width: 100%;
  appearance: none;
  border: 0;
  background: transparent;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;

  padding: 1rem;
  color: var(--color-text-normal);
  text-align: left;
}

.credits__summary {
  font-size: 1.4rem;
  color: var(--color-text-muted);
}

.credits__chev {
  width: 2.2rem;
  height: 2.2rem;
  flex: 0 0 auto;
  opacity: 0.9;
  fill:var(--color-text-normal);
}

.credits__body {
  border-top: 1px solid var(--color-border);
  padding: 1rem;

  font-size: 1.5rem;
  color: var(--color-text-normal);
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.credits__body {
  border-top: 1px solid var(--color-border);
  padding: 1rem;

  display: flex;
  flex-direction: column;
  gap: 0.6rem;

  font-size: 1.5rem;
  color: var(--color-text-normal);
}

.credits__row {
  display: grid;
  grid-template-columns: 12rem 1fr;
  column-gap: 1rem;
  align-items: baseline;
}

.credits__label {
  font-weight: 600;
  color: var(--color-text-muted);
}

.credits__value {
  font-weight: 400;
}


.day-link.is-past {
  opacity: 0.45;
}



.dn-logo {
  position: absolute;
  top: 1.6rem;
  right: 10px;

  width: 26px;
  height: auto;

  opacity: 0.9;
  pointer-events: none;
  user-select: none;
}

.dn-logo.hide {
  display: none;
}

.fem {
  font-weight: 600;
}

.fyra {
  font-weight: 400;
}

</style>